import ProgramType from 'src/types/programType';

export default class NavigationHelper {
  public static getQueryParam = (key: string): string | null => {
    const pattern = `${key}=([^&]+)`;
    const regExp = new RegExp(pattern);
    const match = regExp.exec(window.location.search);
    return match != null ? decodeURIComponent(match[1]) : null;
  };

  public static parseProgramTypeFromPath = (pathname: string): ProgramType | null => {
    const rootPath: string | null = pathname.split('/')[1];
    if (rootPath == null) {
      return null;
    }

    switch (rootPath.toLowerCase()) {
      case 'fresh':
        return ProgramType.AmazonFresh;
      case 'wholefoods':
        return ProgramType.WholeFoods;
      case 'gfc':
        return ProgramType.Gfc;
      case 'gfceu':
        return ProgramType.GfcEu;
      case 'go':
        return ProgramType.Go;
      default:
        return null;
    }
  };

  /**
   * Creates search parameters object that preserves the demo flag if it's active
   * @param params - Base parameters to include
   * @param currentDemo - Current demo parameter value
   * @returns Search parameters object with demo flag preserved if active
   */
  public static createSearchParams = (params: Record<string, string>, currentDemo?: string): Record<string, string> => {
    const searchParams = { ...params };

    // Include demo parameter if it's set to '1'
    if (currentDemo === '1') {
      searchParams.demo = '1';
    }

    return searchParams;
  };
}
